<template><svg xmlns="http://www.w3.org/2000/svg" width="57" height="57" viewBox="0 0 57 57" fill="none">
        <path
            d="M8.48893 6.36621L48.1556 6.3662L48.1556 11.0329L8.48893 11.0329L8.48893 6.36621ZM6.5756 13.3662L50.0689 13.3662L52.8223 27.1352L52.8223 32.0329L49.3223 32.0329L49.3223 50.6995L44.6556 50.6995L44.6556 32.0329L32.9889 32.0329L32.9889 50.6995L7.32228 50.6995L7.32227 32.0329L3.82227 32.0329L3.82227 27.1352L6.5756 13.3662ZM11.9889 32.0329L11.9889 46.0329L28.3223 46.0329L28.3223 32.0329L11.9889 32.0329ZM48.1089 27.3662L46.2423 18.0329L10.4023 18.0329L8.5356 27.3662L48.1089 27.3662Z"
            fill="url(#paint0_linear_1013_41743)" />
        <defs>
            <linearGradient id="paint0_linear_1013_41743" x1="5.85546" y1="11.2152" x2="51.105" y2="14.8178"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#47D18C" />
                <stop offset="1" stop-color="#66A3FF" />
            </linearGradient>
        </defs>
    </svg></template>